export const environment = {
    production: false,
    apiUrl: 'https://bff.abacusau.com/api',
    environmentName: 'local',
    pageTitle:"Abacus",
    storageSecret: "Abacus_UI_Storage_Key_2026"
};

